import { IRegularInfrastructureData, TRegularInfrastructureItem } from '../../../../types/map';

export function toRegularInfrastructureItems(infrastructureByYear: Map<number, IRegularInfrastructureData>) {
  return Array.from(infrastructureByYear.values())
    .flatMap(({ geoObjectsData }) => geoObjectsData)
    .reduce<TRegularInfrastructureItem[]>((acc, datum) => {
      if (datum.infrastructureItem) {
        acc.push(datum.infrastructureItem);
      }

      return acc;
    }, []);
}
